import { render, staticRenderFns } from "./SpecialityCard.vue?vue&type=template&id=3bbd7ed2&scoped=true"
import script from "./SpecialityCard.vue?vue&type=script&lang=js"
export * from "./SpecialityCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbd7ed2",
  null
  
)

export default component.exports